import { Avatar } from "antd";

export default function AvatarProfile({ userInfo }: any) {
    return (
        <div className="avatar-profile">
            <Avatar
                className="circle-avatar-user"
                shape="circle"
                alt="Avatar"
                src={userInfo?.avatar || "../images/img-profile-default-01.png"}
            />
        </div>
    );
}
